module.exports = __webpack_public_path__ + "img/ic_email.9f3a9282.svg";